import React, { useState, useEffect } from "react";
import ContactModal from "../pages/Contact us/Contact";
import AOS from "aos";
import "aos/dist/aos.css";

const Crosole = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
      <div
        className="py-5 d-flex align-items-center"
        style={{
          backgroundColor: "black",
          color: "white",
          minHeight: "500px",
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* Image Section */}
            <div
              className="col-12 col-md-6 order-md-2 text-center"
              data-aos="zoom-in"
              data-aos-duration="1500"
            >
              <img
                src="bannerimage/img.png"
                alt="Banner"
                className="img-fluid shadow-lg"
                style={{ maxHeight: "350px", width: "auto" }}
              />
            </div>

            {/* Text Section */}
            <div
              className="col-12 col-md-6 order-md-1 text-center text-md-start"
              style={{ paddingRight: "2rem" }}
            >
              <p
                data-aos="fade-up"
                className="text-primary fs-4 fw-semibold"
                style={{ color: "#05f7e2" }}
              >
                Effortless
              </p>
              <h1
                data-aos="fade-up"
                data-aos-delay="500"
                className="display-4 fw-bold"
              >
                A trusted partner in
              </h1>
              <p
                data-aos="fade-up"
                data-aos-delay="750"
                className="fs-5"
                style={{ color: "#05f7e2" }}
              >
                simplifying logistics
              </p>
              <button
                data-aos="fade-up"
                data-aos-delay="1000"
                className="btn btn-primary px-4 py-2 rounded-pill mt-3"
                style={{ backgroundColor: "#05f7e2", color: "black" }}
                onClick={handleShow}
              >
                Join us
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ContactModal Component */}
      <ContactModal show={showModal} handleClose={handleClose} />
    </>
  );
};

export default Crosole;
